module.exports = __webpack_public_path__ + "static/media/template-hd4.126e170b.png";